import { render } from "./ViewHeader.vue?vue&type=template&id=0ac3020c"
import script from "./ViewHeader.vue?vue&type=script&lang=js"
export * from "./ViewHeader.vue?vue&type=script&lang=js"

import "./ViewHeader.vue?vue&type=style&index=0&id=0ac3020c&lang=css"

import exportComponent from "/builds/2022/edf_re_aos/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__